import { lazy } from "react";
import CommonLayout from "layout/CommonLayout";
import Loadable from "components/Loadable";
const MapsPage = Loadable(lazy(() => import("pages/maps/list")));

const GuestRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <CommonLayout />,
      children: [
        {
          path: "rent",
          element: <MapsPage />,
        },
      ],
    },
  ],
};

export default GuestRoutes;